module.exports = __webpack_public_path__ + "img/fb_Share.ae55a858.png";